import { fetchClientMaterials } from '$api/client'

const INTERNAL_PROPERTIES = [
  // {
  //   set top level properties explicitly:
  //   name: 'some_name'  // used as attribute key in DB and Form.Item names
  //   label: 'Some Name' // display label
  //
  //   set one of following two bools to add to respective attribute array instead:
  //   float_attribute: true
  //   attributes: true
  //
  //   settings:
  //   required: true
  //   units: {
  //     <unit>: <scale factor relative to default unit> e.g.:
  //     mm: 1, // unit with value 1 will be default
  //     cm: 10, // scaled by 10 relative to mm
  //     m: 1000,
  //   }
  // }
  {
    name: 'id_part_client',
    label: 'Part No',
    required: true,
    units: {},
  },
  {
    name: 'name',
    label: 'Part Name',
    required: true,
  },
  {
    name: 'Width',
    float_attribute: true,
    required: true,
    units: {
      mm: 1,
      cm: 10,
      m: 1000,
    },
    min: 1,
  },
  {
    name: 'Depth',
    float_attribute: true,
    required: true,
    units: {
      mm: 1,
      cm: 10,
      m: 1000,
    },
    min: 1,
  },
  {
    name: 'Height',
    float_attribute: true,
    required: true,
    units: {
      mm: 1,
      cm: 10,
      m: 1000,
    },
    min: 1,
  },
  {
    name: 'Weight',
    float_attribute: true,
    units: {
      mg: 0.001,
      g: 1,
      kg: 1000,
    },
    min: 1,
  },
  {
    name: 'Internal Material',
    attribute: true,
    useOptions: () => {
      return {
        queryKey: ['clientMaterialsListForDropdown'],
        queryFn: () =>
          fetchClientMaterials({
            queryKey: [
              'clientMaterialsListForDropdown',
              { page: 1, size: 100 },
            ],
          }),
        select: (data) => {
          if (!data || !Array.isArray(data.items)) return []
          return data.items.map((material) => ({
            value: material.id,
            label: material.name,
          }))
        },
      }
    },
  },
  {
    name: 'Price',
    float_attribute: true,
    units: {
      ct: 0.01,
      EUR: 1,
    },
  },
  {
    name: 'Price AM',
    float_attribute: true,
    units: {
      ct: 0.01,
      EUR: 1,
    },
  },
]

export default INTERNAL_PROPERTIES
